// extracted by mini-css-extract-plugin
module.exports = {"NewFormContent":"NewFormContent___dv61W"};